interface IErrorWithType {
  response?: {
    data?: {
      type?: string;
    };
  };
}

export const resolveTypeBasedErrorContent = ({
  error,
  namespace,
  fallbackKey,
  t,
  te,
}): string => {
  const errorType =
    (error as IErrorWithType)?.response?.data?.type || (error as any)?.type;
  const typeKey = `${namespace}.${errorType}`;

  if (te(typeKey)) {
    return t(typeKey);
  }

  return t(fallbackKey);
};
